// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx, css } from '@emotion/react';

import * as themeColors from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import {
	akEditorSmallZIndex,
	avatarColors,
	relativeFontSizeToBase16,
} from '@atlaskit/editor-shared-styles';

// CSS for the small violator/badge in the bottom right of each avatar
export const badge = (backgroundColor: string, textColor: string) =>
	css({
		display: 'block',
		position: 'absolute',
		right: '1px',
		bottom: '1px',
		width: '13px',
		height: '13px',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		zIndex: akEditorSmallZIndex,
		borderRadius: '3px',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		background: backgroundColor,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		color: textColor,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		fontSize: relativeFontSizeToBase16(9),
		lineHeight: 0,
		paddingTop: token('space.100'),
		textAlign: 'center',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		boxShadow: `0 0 1px ${token('color.border.inverse', themeColors.N0)}`,
		boxSizing: 'border-box',
	});

const avatarBadgeTextColor = token('color.text.inverse', '#FFFFFF');

const getAvatarBadgeColor = (sessionId: String): { backgroundColor: string; textColor: string } => {
	/* eslint-disable no-bitwise */
	const deterministicHashFromSessionid = sessionId
		.split('')
		.reduce((hash, char) => ((hash << 5) - hash + char.charCodeAt(0)) | 0, 0);
	/* eslint-enable no-bitwise */
	const colorIndexFromHash = Math.abs(deterministicHashFromSessionid) % avatarColors.length;

	return {
		backgroundColor: avatarColors[colorIndexFromHash],
		textColor: avatarBadgeTextColor,
	};
};

export const AvatarBadge = (props: { name: string; sessionId: string }) => {
	const { backgroundColor, textColor } = getAvatarBadgeColor(props.sessionId);
	const firstInitialOfName = props.name.substring(0, 1).toUpperCase();
	return jsx(
		'div',
		{
			css: badge(backgroundColor, textColor),
			'data-testid': 'editor-presence-avatar-item',
		},
		firstInitialOfName,
	);
};
